import axios from "axios";
import api from "./api";
import { message } from "antd";

const handleError = (error) => {
  const message =
    error.response?.data?.DisplayMessage ||
    error.response?.data?.Message ||
    error.message ||
    "Something went wrong";
  throw new Error(message);
};

export const getDivisionApi = async () => {
  try {
    const response = await api.get(`/Category/getalldivisions`);
    return response?.data || [];
  } catch (error) {
    handleError(error);
    return [];
  }
};
export const getDepartmentApi = async (id) => {
  try {
    const response = await api.get(
      `/Category/getDepartmentByDivisionUserid/${id}`,
    );
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};
export const vendorSaveApi = async (form) => {
  try {
    const response = await api.post(`/VendorRegistration/vendorTrigger`, form);
    if (response?.data?.IsSuccess === true) {
      message.success(response?.data?.DisplayMessage);
    } else {
      message.error(response?.data?.DisplayMessage);
    }

    return response?.data;
  } catch (error) {
    handleError(error);
  }
};
export const sendReminderApi = async (id) => {
  try {
    const response = await api.get(
      `/VendorRegistration/getSendReminderEmail/${id}`,
    );
    return response?.data || {};
  } catch (error) {
    handleError(error);
  }
};
export const getTriggerListApi = async () => {
  try {
    const response = await api.get(
      `/VendorRegistration/getTriggerListByUserID`,
    );
    return response?.data || [];
  } catch (error) {
    handleError(error);
  }
};
export const getStateApi = async (id) => {
  try {
    const response = await api.get(`/State`);
    return response?.data || [];
  } catch (error) {
    handleError(error);
  }
};
export const getCityApi = async (id) => {
  try {
    const response = await api.get(`/City`);
    return response?.data || [];
  } catch (error) {
    handleError(error);
  }
};
export const vendorGeneralInfoSubmitApi = async (form) => {
  try {
    const response = await api.post(`/VendorRegistration/generalInfo`, form);
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};
export const vendorBasicInfoSubmitApi = async (form) => {
  try {
    const response = await api.post(`/VendorRegistration/basicData`, form);
    if(response?.data?.IsSuccess===false){
      message.error(response?.data?.DisplayMessage)
    }
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};
export const getVendorProfileApi = async () => {
  try {
    const response = await api.get(
      `/VendorRegistration/getVendorProfileByUserID`,
    );
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

export const getVendorListApi = async (status, from, to) => {
  try {
    const response = await api.get(
      `/VendorRegistration/getVendorListForApprove/${status}/${from}/${to}`,
    );
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

export const getVendorReportsApi = async (from, to) => {
  try {
    const response = await api.get(
      `/VendorRegistration/getVendorReport/${from}/${to}`,
    );
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

export const getVendorDetailByGUIDApi = async (id) => {
  try {
    const response = await api.get(
      `/VendorRegistration/getVendorDetailByGuid/${id}`,
    );
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

export const getApprovedStatusApi = async (id) => {
  try {
    const response = await api.get(
      `/VendorRegistration/getApprovedStatus?vendorguid=${id}`,
    );
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

export const getVendorStatusReportApi = async (id) => {
  try {
    const response = await api.get(
      `/VendorRegistration/getVendorStatusReport?vendorguid=${id}`,
    );
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

export const CommercialTermsApi = async (form) => {
  try {
    const response = await api.post(
      `/VendorRegistration/commericalTerms`,
      form,
    );
      if(response?.data?.IsSuccess===false){
      message.error(response?.data?.DisplayMessage)
    }
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

export const tradeSupportApi = async (form) => {
  try {
    const response = await api.post(
      `/VendorRegistration/tradeSupportTerms`,
      form,
    );
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

export const documentsSubmitApi = async (form) => {
  try {
    const response = await api.post(`/VendorRegistration/document`, form);
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

export const submitApplicationApi = async (form) => {
  try {
    const response = await api.post(
      `/VendorRegistration/submitapplication`,
      form,
    );
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

export const approveApplicationApi = async (form) => {
  try {
    const response = await api.post(`/VendorRegistration/approvevendor`, form);
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};

export const rejectApplicationApi = async (form) => {
  try {
    const response = await api.post(`/VendorRegistration/rejectvendor`, form);
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};
export const getBusinessTypeApi = async (id) => {
  try {
    const response = await api.get(`/VendorRegistration/getBusinessType`);
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};
export const panValidationApi = async (form) => {
  try {
    const response = await api.post(`SAPIntegration/validate/panumber/${form}`);
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};
export const gstValidationApi = async (form) => {
  try {
    const response = await api.post(`SAPIntegration/validate/gstin/${form}`);
    return response?.data;
  } catch (error) {
    handleError(error);
  }
};
export const getCategoryByUserIdApi = async () => {
  try {
    const response = await api.get(`/Category/getCategoryByUserid`);
    return response?.data || [];
  } catch (error) {
    handleError(error);
    return [];
  }
};

export const updateLegalName = async (guid) => {
  try {
    const response = await api.post(
      `/SAPIntegration/validate/updatelegalname/${guid}`,
    );
    return response?.data || [];
  } catch (error) {
    handleError(error);
  }
};


export const syncVendorReportApi = async (vendorGuid) => {
  try {
    const response = await api.post(`/SAPIntegration/syncVendorMaster/${vendorGuid}`);
    if (response?.data?.IsSuccess === true) {
      message.success(response?.data?.DisplayMessage);
    } else {
      message.error(response?.data?.DisplayMessage);
    }

    return response?.data;
  } catch (error) {
    handleError(error);
  }
};
export const getTradeTypeApi = async () => {
  try {
    const response = await api.get(`/VendorRegistration/getVendorType`);
    return response?.data || [];
  } catch (error) {
    handleError(error);
    return [];
  }
};
export const getDepartmentTradeTypeApi = async () => {
  try {
    const response = await api.get(`/Department`);
    return response?.data || [];
  } catch (error) {
    handleError(error);
    return [];
  }
};
